import { lazy } from 'react';
import { DASHBOARD_PERMISSIONS } from './constants';

const DashboardPage = lazy(() => import('./pages/DashboardPage'));

export const dashboardRoutes = [
  {
    path: '/',
    element: DashboardPage,
    permission: DASHBOARD_PERMISSIONS.READ,
    nav: { labelKey: 'nav.dashboard', icon: 'DashboardOutlined', group: 'main' },
  },
];
